module.exports = __webpack_public_path__ + "img/tabelaMobile.12c690e8.svg";